import React, { useEffect, useState } from 'react';
//import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Loading from '../../components/Sign/Loading';
import SignatureSection from './SignatureSection';
import { Grid } from '@material-ui/core';
import { getDocumentToSign, setUrlService } from "../../actions/sign.action";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from 'notistack';
import "./signature.css";

/*const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	body: {
		backgroundImage: 'url(../styles/StylesBody.css)',
		backgroundPosition: '0 -50%  0 -50% !important',
		backgroundSize: '100% 400px !important',
	},
	paper: {
		padding: '35px',
		marginTop: '-25px',
		borderRadius: '10px',
		width: '100%',
	},
	gridItem: {
		margin: '15px 5px 0',
		marginLeft: '20px',
		justifyItems: 'right;'
	},
	buttonContainer: {
		marginTop: '20px',
		marginBottom: '20px',
	},
}));*/

const Signatures = (props) => {
	let params = new URLSearchParams(window.location.search);
	const [transactionId] = useState(params.get("transactionId") ?? "");
	const [isLoading, setLoading] = useState(true);
	const dispatch = useDispatch();
	const { enqueueSnackbar } = useSnackbar();
	const { getDocumentToSignResponse, getDocumentToSignResponseError } = useSelector((store) => store.sign);
	const { getEnterpriseByIDResponse } = useSelector((store) => store.enterpriseReducer);

	useEffect(() => {
		document.body.className = 'bodyMiddle';
	});

	useEffect(() => {
		if(getEnterpriseByIDResponse.monitoringService){
			setUrlService(getEnterpriseByIDResponse.monitoringService);
			if(transactionId){
				dispatch(getDocumentToSign(transactionId, enqueueSnackbar));
				setLoading(true);
			}		
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [getEnterpriseByIDResponse]);
	
	useEffect(() => {
		if(getDocumentToSignResponse || !transactionId){
			setLoading(false);
		}
		if(getDocumentToSignResponseError){
			setLoading(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getDocumentToSignResponse, getDocumentToSignResponseError]);

	return (
		<>
			{(isLoading) &&
				<Loading />
			}
			<Grid container spacing={0} direction="row">
				{/* <Container component="main" maxWidth="lg">
					<h1 className={'title-background'}>Firmar documentos</h1>
				</Container> */}
				<Container component="main" >
					<Grid
						container
						spacing={0}
						direction="row"
						justifyContent="flex-start"
						alignItems="flex-start"
						className="zone-upload-container"
						maxWidth="md"
					>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							{getDocumentToSignResponse || !transactionId ? (
								<SignatureSection 
								isDashboard={false} 
								transactionId={transactionId} 
								getDocumentToSignResponse={getDocumentToSignResponse}
								getDocumentToSignResponseError={getDocumentToSignResponseError}
							/>
							) : null}
						</Grid>
					</Grid>
				</Container>
			</Grid>
		</>
	);
};

export default (Signatures);
